import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IRenameFilePlacementParams {
  filePlacementId: string;
  name: string;
}

export async function renameFilePlacement({
  filePlacementId,
  name,
}: IRenameFilePlacementParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file-placement/rename', {
    method: 'POST',
    body: { filePlacementId, name },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to rename file',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
